module.exports = __webpack_public_path__ + "img/SC12-Next_steps.534e21f6.png";